// #739: the second half of a driver login that returned status "consent_required".
// Records the driver's consent choices, after which the backend creates the session.
// Shared by the login modal (ChatLayout) and the shop referral page.

export const isLoginConsentRequired = (data) => data?.status === 'consent_required' && Boolean(data?.consent_token);

export async function acceptLoginConsent(authBaseUrl, { consentToken, consent }) {
    const response = await fetch(`${authBaseUrl}/accept-login-consent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ consent_token: consentToken, consent }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data?.detail || data?.error || 'Could not finish logging in.');
    return data;
}
